import React from 'react';
import PropTypes from 'prop-types';
export default function IconInfoFull({ className }){
  return(
    <svg className={className} fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.9992 -0.0020752C31.0466 -0.0020752 40.0023 8.95362 40.0023 20.001C40.0023 31.0484 31.0466 40.0041 19.9992 40.0041C8.95179 40.0041 -0.00390625 31.0484 -0.00390625 20.001C-0.00390625 8.95362 8.95179 -0.0020752 19.9992 -0.0020752ZM19.9916 16.4991C18.9659 16.4998 18.1211 17.2724 18.0062 18.2671L17.9929 18.5004L18.0001 29.5036L18.0137 29.7368C18.1299 30.7314 18.9757 31.5029 20.0014 31.5023C21.0271 31.5016 21.8719 30.729 21.9868 29.7342L22.0001 29.501L21.9929 18.4978L21.9793 18.2645C21.8631 17.2699 21.0173 16.4984 19.9916 16.4991ZM20.0001 8.99999C18.6177 8.99999 17.4971 10.1206 17.4971 11.503C17.4971 12.8854 18.6177 14.0061 20.0001 14.0061C21.3825 14.0061 22.5031 12.8854 22.5031 11.503C22.5031 10.1206 21.3825 8.99999 20.0001 8.99999Z" fill="#5E811E"/>
    </svg>
  );
}
IconInfoFull.propTypes = {
  className: PropTypes.string,
};
